import { useEffect, useRef, useState } from "react";

import cn from 'classnames'
import styles from './index.module.scss'

export default SearchableDropdown = ({
  options,
  handleChange
}) => {

  const [query, setQuery] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [selected, setSelected] = useState(false)

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => document.removeEventListener("click", toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => "")
    handleChange(option)
    setSelected(option)
    setIsOpen((isOpen) => !isOpen)
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current)
  }

  const getDisplayValue = () => {
    if (query) return query
    if (selected) return selected.label

    return ""
  };

  const filter = (options) => {
    return options.filter(
      (option) => option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  };
  

  return (
    <div className={styles.dropdown}>
      <div className="control">
        <div className={cn(styles.selectedValue)}>
          <input
            ref={inputRef}
            type="text"
            placeholder="Search for a customer"
            value={getDisplayValue()}
            name="searchTerm"
            onChange={(e) => {
              setQuery(e.target.value);
            }}
            onClick={toggle}
          />
        </div>
        <div className={cn(styles.arrow, isOpen && styles.open)}></div>
      </div>

      <div className={cn(styles.options, isOpen && styles.open)}>
        {filter(options).map((option, index) => {
          return (
            <div
              onClick={() => selectOption(option)}
              className={cn(styles.option, selected && selected.value === option.value ? styles.selected : null)}
              key={option.value}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
